// web/src/stores/commandPaletteStore.ts
// Cross-route hand-off of a prompt into the Luna chat input.
//
// Used by X-Ray's "Discuss with Luna" seed and any other surface that wants
// to drop text into the composer from a different route: stage the prompt
// here, navigate to /, and AgentsPage consumes it. A store value (not
// sessionStorage) is what makes the "already on /" case work — navigate("/")
// is a no-op there, so a mount-time effect would never fire.
import { create } from "zustand";
export const useCommandPaletteStore = create((set) => ({
    pendingChatPrompt: null,
    setPendingChatPrompt: (prompt) => set({ pendingChatPrompt: prompt }),
    consumePendingChatPrompt: () => set({ pendingChatPrompt: null }),
}));
